import { useEffect, useRef } from 'react';
import { setDocumentTitle } from '../util';

const useTitle = (title, keepTitleOnUnmount = false) => {
  const defaultTitle = useRef(document.title);

  useEffect(() => {
    setDocumentTitle(title);
  }, [title]);

  useEffect(() => () => {
    if (!keepTitleOnUnmount) {
      document.title = defaultTitle.current;
    }
  }, []);
};

export default useTitle;
